<template>
  <div class="bg">
    <div class="login-box">
      <el-form :model="loginForm"
               :rules="rules2"
               ref="loginForm"
               label-position="left"
               label-width="0px"
               class="demo-ruleForm login-container">
        <h3 class="title">{{ $t('text.adminConsole') }}</h3>
        <div class="login-text">{{ $t('text.loginTitle') }}</div>
        <el-form-item prop="loginName">
          <el-input type="text"
                    v-model="loginForm.loginName"
                    auto-complete="off"
                    :placeholder="$t('text.username')"/>
        </el-form-item>
        <el-form-item prop="loginPassword">
          <el-input type="password"
                    v-model="loginForm.loginPassword"
                    auto-complete="off"
                    :placeholder="$t('text.password')"/>
        </el-form-item>
        <el-form-item prop="gAuthCode">
          <el-input type="text"
                    v-model="loginForm.gAuthCode"
                    auto-complete="off"
                    :placeholder="$t('text.googleAuthCode')"/>
        </el-form-item>
        <el-form-item prop="emailAuthCode" v-show="isShowEmailAuthCode && currentRole === 'manager'">
          <el-row>
            <el-col :span="14">
              <el-input type="text"
                        v-model="loginForm.emailAuthCode"
                        auto-complete="off"
                        :placeholder="$t('text.emailAuthCode')"/>
            </el-col>
            <el-col :span="10">
              <el-button type="warning" @click="sendEmailAuthCode" :loading="logining">
                {{ $t('text.sendEmailAuthCode') }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="login-error-message" style="
          text-align: left;
          color: red;
          margin-top: 15px;
          margin-bottom: 15px;
        ">
          {{ errorMsg }}
        </div>

        <div id="cf-turnstile" class="cf-turnstile" v-show="isShowVerifyTurnstile"/>

        <el-form-item style="width: 100%">
          <el-button type="primary"
                     style="width: 100%"
                     @click.native.prevent="handleSubmit2"
                     :loading="logining">{{ $t('text.login') }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-col :span="12">
            <el-select v-model="currentLocale">
              <el-option value="zh" label="中文"/>
              <el-option value="en" label="English"/>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-select v-model="currentRole">
              <el-option value="user" :label="$t('text.user')"/>
              <el-option value="manager" :label="$t('text.manager')"/>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <UpdatePassword :show.sync="showUpdatePasswordDialog" :action="'firstLogin'"></UpdatePassword>
  </div>
</template>

<script>
import UpdatePassword from '@/components/UpdatePassword.vue'

export default {
  components: {
    UpdatePassword: UpdatePassword,
  },
  data() {
    return {
      logining: false,
      showUpdatePasswordDialog:false,
      loginForm: {
        loginName: '',
        loginPassword: '',
        gAuthCode: '',
        emailAuthCode: '',
      },
      rules2: {
        loginName: [
          {required: true, message: this.$t('message.inputLoginName'), trigger: 'blur'},
        ],
        loginPassword: [
          {required: true, message: this.$t('message.inputPassword'), trigger: 'blur'},
        ],
        gAuthCode: [
          {required: true, message: this.$t('message.inputGoogleAuthCode'), trigger: 'blur'},
        ],
      },
      checked: true,
      errorMsg: '',
      siteKey: '',
      isShowVerifyTurnstile: false,
      isShowEmailAuthCode: false,
      siteKeyLoading: null,
      turnstileToken: '',
      turnstileWidgetId: null,
    }
  },
  methods: {
    // handleReset2() {
    //   this.$refs.loginForm.resetFields()
    //   this.resetTurnstile()
    // },
    handleSubmit2() {
      let _this = this
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return false
        }

        if (this.isShowVerifyTurnstile && !this.turnstileToken) {
          this.errorMsg = this.$t('message.completeHumanVerification')
          return false
        }

        this.logining = true
        let loginParams = {
          loginName: this.loginForm.loginName,
          loginPassword: this.loginForm.loginPassword,
          sysId: _this.$store.state.sysId,
          gAuthCode: this.loginForm.gAuthCode,
          emailAuthCode: this.loginForm.emailAuthCode,
          turnstileToken: this.turnstileToken,
        }
        this.axios
            .post('/auth/authInfo', loginParams)
            .then(res => {
              this.logining = false
              if (res.code === 200) {
                this.$store.commit('setIsLogin', true)
                this.$store.commit('setUserId', res.data.userId)
                this.$store.commit('setUserName', res.data.userName)
                this.$store.commit('setRoutes', res.data.routes)
                this.$store.commit('setToken', res.data.token)
                this.$store.commit('setProdStatus', res.data.prodStatus)
                this.$store.commit('setRoleId', res.data.roleId)
                this.$store.commit('setCreditFlag', res.data.creditFlag)
                this.$store.commit('setCountry', res.data.country)
                this.$store.commit('setPayplatformName', res.data.payplatformName)
                this.$store.commit('setIsFirstLogin', res.data.isFirstLogin)
                sessionStorage.setItem(
                    'store',
                    JSON.stringify(this.$store.state)
                )
                if (res.data.isFirstLogin === true) {
                  this.showUpdatePasswordDialog = true;
                } else {
                  this.$router.push('/')
                }
              } else {
                this.errorMsg = res.msg
                this.checkShowTurnstile()
              }
            })
            .catch(() => {
              this.logining = false
              this.checkShowTurnstile()
            })
      })
    },
    checkShowTurnstile() {
      if (this.isShowVerifyTurnstile) {
        this.resetTurnstile()
        return
      }
      this.axios.get('/auth/turnstileSiteKey', {params: {}}).then(res => {
        if (res.code === 200) {
          this.siteKey = res.data.turnstileSiteKey
          this.isShowVerifyTurnstile = res.data.isVerifyTurnstile
          if (this.isShowVerifyTurnstile) {
            this.resetTurnstile()
          }
        }
      })
    },
    loadTurnstileSiteKey() {
      if (this.siteKey) {
        return Promise.resolve(this.siteKey)
      }
      if (this.siteKeyLoading) {
        return this.siteKeyLoading
      }

      this.siteKeyLoading = this.axios.get('/auth/turnstileSiteKey', {params: {}}).then(res => {
        if (res.code === 200) {
          this.siteKey = res.data.turnstileSiteKey
          this.isShowVerifyTurnstile = res.data.isVerifyTurnstile
          return this.siteKey
        }
        this.errorMsg = res.msg
        throw new Error(res.msg || 'failed to load turnstile site key')
      }).finally(() => {
        this.siteKeyLoading = null
      })

      return this.siteKeyLoading
    },
    initTurnstile() {
      if (this.turnstileWidgetId !== null || !window.turnstile || !this.siteKey || !document.getElementById('cf-turnstile')) {
        return
      }

      this.turnstileWidgetId = window.turnstile.render('#cf-turnstile', {
        sitekey: this.siteKey,
        language: this.currentLocale === 'zh' ? 'zh-CN' : 'en',
        callback: token => {
          this.turnstileToken = token
        },
        'expired-callback': () => {
          this.turnstileToken = ''
        },
        'error-callback': () => {
          this.turnstileToken = ''
        },
      })
    },
    resetTurnstile() {
      this.turnstileToken = ''
      if (window.turnstile && this.turnstileWidgetId !== null) {
        window.turnstile.reset(this.turnstileWidgetId)
      }
    },
    sendEmailAuthCode() {
      this.logining = true;
      this.axios.get('/auth/emailVerificationCode', {params: {
          loginName: this.loginForm.loginName,
          sysId: this.$store.state.sysId,
        }
      }).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
          this.logining = false;
        }else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
          this.logining = false;
        }
      })
    },
    checkShowEmailAuthCodeTime() {
      // 1. 強制取得巴基斯坦時區 (Asia/Karachi) 的目前小時數
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Karachi',
        hour: 'numeric',
        hour12: false
      });

      // 轉成數字以利後續比較
      const hours = parseInt(formatter.format(new Date()), 10);

      // 2. 判斷邏輯 晚上 19:00 到 隔天 11:00 之間顯示
      this.isShowEmailAuthCode = (hours >= 19 || hours < 11);

      // console.log("巴基斯坦目前小時 (hours):", hours);
      // console.log("isShowEmailAuthCode:", this.isShowEmailAuthCode);
    }
    // showCaptcha() {
    //   this.$axios.post('/captcha/show', {}).then(res => {
    //     this.captchaPic = 'data:image/png;base64,' + res.img
    //     this.loginForm.captchaKey = res.key
    //   })
    // }
  },
  created() {
    // this.showCaptcha()
  },
  async mounted() {
    try {
      await this.checkShowEmailAuthCodeTime()
      await this.loadTurnstileSiteKey()
    } catch (e) {
      console.warn('[Turnstile] Initialization skipped due to siteKey load failure')
      return
    }

    const timer = window.setInterval(() => {
      if (window.turnstile) {
        window.clearInterval(timer)
        this.$nextTick(() => {
          this.initTurnstile()
        })
      }
    }, 100)
  },
  computed: {
    currentLocale: {
      get() {
        return this.$i18n.getLocale();
      },
      set(value) {
        this.$i18n.setLocale(value);

      }
    },
    currentRole: {
      get() {
        return this.$store.state.currentRole === 'manager' ? 'manager' : 'user';
      },
      set(value) {
        this.$store.commit('setCurrentRole', value);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 0 auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: rgba(0, 0, 0, 0.5);
  /*border: 1px solid #eaeaea;*/
  /*box-shadow: 0 0 12px #9e9e9e;*/

  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #ffffff;
  }

  .remember {
    float: left;
    margin-bottom: 15px;
  }
}

.cf-turnstile {
  width: 300px;
  min-height: 65px;
  margin: 0 auto;
}

.bg {
  background: url('../assets/bg.jpg') no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  width: 100vw;
  height: calc(100vh - 180px);
  padding-top: 180px;
  text-align: center;

  .tgContact {
    padding-top: 50px;
    text-align: center;
    color: #ffffff;
  }
}
</style>
